<template>
		<div id="pageRoot">
			
			<p id="text01">
				Pero ya dije que don Fito es un hombre lleno de paciencia.<br><br>
				—¡Hop, Venancio! —lo mandaba de vuelta al techo. Pero antes de que Venancio pusiese una sola pata en las tejas, le gritaba de repente: —¡Acá, Venancio!<br><br>
				Entonces Venancio, que siempre fue un perro muy obediente, se daba media vuelta en el aire y volvía. Era una prueba dificilísima.<br><br> 
				Al principio Venancio perdía el equilibrio y rodaba por la vereda como una maceta. Pero con el tiempo aprendió a aterrizar mucho mejor.<br><br>
				Don Fito estaba cada día más orgulloso de su perro.<br><br>
				—¡Ya estás por aprender a volar, Venancio! —le decía palmeándole la cabeza.<br><br>
				Y Venancio decía "arf, arf, arf" y movía la cola. Por fin un día lo mandó volando a la carnicería, que queda a dos cuadras.<br><br>
				—Hop, a lo de Gorosito, Venancio! —le gritó (Gorosito es nuestro carnicero).<br><br>
				¡Y Venancio voló las dos cuadras!(¡Un poco porque era tan obediente<br>
				y otro poco porque Gorosito siempre le regalaba algún hueso!<br><br>
			</p>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-listen"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#text01
{
position: absolute;
left: 4.98%;
right: 4.98%;
top: 7.68%;
bottom: 13.28%;
margin: 0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 26px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p53-57/V16.mp4"]
    }
  }
}
</script>